import { Module } from 'vuex';
import { createDirectory } from '../create/store/create-directory.store';
import { IDirectoryState } from './directory.types';
import { RootState } from '@/store/store';
import { actions } from '@/content-library/directories/store/directory.actions';
import { mutations } from '@/content-library/directories/store/directory.mutations';
import { state } from '@/content-library/directories/store/directory.constants';
import { deleteDirectory } from '@/content-library/directories/delete/store/delete-directory.store';
import { updateDirectory } from '@/content-library/directories/update/store/update-directory.store';
import { directoryTree } from '@/content-library/directories/tree/store/directory-tree.store';

export const directories: Module<IDirectoryState, RootState> = {
  namespaced: true,
  actions,
  mutations,
  modules: { deleteDirectory, createDirectory, updateDirectory, directoryTree },
  state,
};
